import Docs from './docs/Docs';
import Main from './main/Main';
import './App.css'
import { HashRouter, Route, Routes, Navigate } from 'react-router-dom'

function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/main" element={<Main />} />
        <Route path="*" element={<Docs />} />
        {/* <Route path="*" element={<Navigate to="/docs" />} /> */}
      </Routes>
    </HashRouter>
  );
}

export default App;

